<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-teamleader-subnav></app-teamleader-subnav>
    </app-sidebar>

    <app-content>
        <app-teamleader-not-logged-in (credentialsIsset)="checkCredentials($event)"></app-teamleader-not-logged-in>

        <div *ngIf="isset">
            <div class="app__title">
                <h1>Contacts Overview</h1>
            </div>

            <app-searchbar [(value)]="filter"></app-searchbar>

            <div *ngIf="this.isLoading">
                <app-loading-message></app-loading-message>
            </div>

            <div
                class="m-t-4"
                *ngIf="!this.isLoading">
                <table
                    class="table-view"
                    *appIsPermitted="{
                        module: 'TEAMLEADER',
                        operator: 'AND',
                        actions: ['READ']
                    }">
                    <thead>
                        <th>Name</th>
                        <th>Emails</th>
                        <th>Iban</th>
                        <th>Language</th>
                        <th>Telephone</th>
                        <th>Open with teamleader</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let contact of this.teamleaderContacts$ | async | filterBy: ['first_name', 'last_name']:filter">
                            <td>{{ contact.first_name }} {{ contact.last_name }}</td>
                            <td>
                                <p *ngFor="let email of contact.emails">
                                    {{ email.email }}
                                </p>
                            </td>
                            <td>{{ contact.iban }}</td>
                            <td>{{ contact.language }}</td>
                            <td>
                                <p *ngFor="let phone of contact.telephones">
                                    {{ phone.number }}
                                </p>
                            </td>
                            <td>
                                <a [href]="contact.web_url">View {{ contact.first_name }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </app-content>
</app-app-holder>
